import React, { Component } from "react"
import styled from "styled-components"
import { Alert } from "reactstrap"
import lodash from "lodash"

import Address from "components/Address"

const Wrapper = styled.div``

const TableWrapper = styled.div`
  min-height: 0px;
  max-height: 60vh;
  overflow-y: auto;
  margin-top: 10px;
`

const StatisticsWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row;
`

const StatisticsItemWrapper = styled.div`
  padding: 15px;
`

const statsMap = {
  dublicateEntries: {
    index: 4,
    label: "Duplikate",
    icon: "clone"
  },
  importedEntries: {
    index: 1,
    label: "Importiert"
  },
  invalidEntries: {
    index: 3,
    label: "Fehlerhaft",
    color: "danger",
    icon: "exclamation-triangle"
  },
  totalEntries: {
    index: 0,
    label: "Gesamt"
  },
  validEntries: {
    index: 2,
    label: "Gültig",
    color: "success",
    icon: "check"
  }
}

const StatisticsItem = ({ label, icon, color, value }) => (
  <StatisticsItemWrapper>
    <h6>{label || "???"}</h6>
    <h4 className={color ? `text-${color}` : ""}>
      {icon && (
        <span>
          <i className={`fas fa-${icon}`} />{" "}
        </span>
      )}
      {value}
    </h4>
  </StatisticsItemWrapper>
)

const Statistics = ({ data }) => (
  <StatisticsWrapper>
    {lodash
      .sortBy(
        lodash.keys(data).map(key => ({ ...lodash.get(statsMap, key), key })),
        "index"
      )
      .map(item => (
        <StatisticsItem {...item} value={data[item.key]} />
      ))}
  </StatisticsWrapper>
)

class Result extends Component {
  render() {
    const { result } = this.props
    if (!result) return null
    const { statistics, invalidEntries = [], values: { preview } = {} } =
      result || {}
    return (
      <div>
        <div>
          {preview ? (
            <Alert color="warning">
              <b>{i18n.t(`note`, `Hinweis`)}</b> {i18n.t(
                'preview_of_addresses_found_click_confirm_to_complete',
                `Dies ist eine Vorschau der gefundenen Adressen. Klicken Sie auf Bestätigen, um den Vorgang abzuschliessen.`)}
            </Alert>
          ) : (
            <Alert color="success">
              {i18n.t(
              'address_list_was_succesfully_transferred_import_result_is_displayed',
              'Die Adressliste wurde erfolgreich übertragen. Das Importergebnis wird unterhalb angezeigt.')}
            </Alert>
          )}
        </div>
        <div>
          <Statistics data={statistics} />
        </div>
        {!lodash.isEmpty(invalidEntries) && (
          <React.Fragment>
            <h4>
              {preview
                ? "Folgende Adressen sind fehlerhaft und können nicht eingelesen werden"
                : "Folgende Adressen sind fehlerhaft und wurden nicht eingelesen"}
              :
            </h4>
            <TableWrapper>
              <table className="table">
                <thead hidden>
                  <tr>
                    <th />
                    <th>Adresse</th>
                  </tr>
                </thead>
                <tbody>
                  {invalidEntries.map((address, index) => (
                    <tr>
                      <th width={50}>{index + 1}.</th>
                      <td>
                        <Address {...address} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </TableWrapper>
          </React.Fragment>
        )}
      </div>
    )
  }
}

export default Result
